import { useState } from "react";
import { useOutletContext } from "react-router-dom";

export default function useFormUtility(data, dataHasChanges = false) {

    const [showNotification, showPrompt] = useOutletContext();

    const [formData, setFormData] = useState(
        {
            data: data ?? null,
            settings: {
                hasChanges: data && dataHasChanges ? true : false,
                saveInProgress: false,
                deleteInProgress: false
            }
        }
    );

    function handleChange(fieldValues) {
        if (!fieldValues || fieldValues.length < 1)
            return;
            
        setFormData(x => {
            let newFormData = JSON.parse(JSON.stringify(x));

            fieldValues.forEach(fv => {
                let fieldParts = fv.field.split(".");
                let current = newFormData.data;
                fieldParts.forEach((f, i) => {
                    i + 1 === fieldParts.length
                        ? current[f] = fv.value
                        : current = current[f];
                });
            });

            newFormData.settings.hasChanges = true;

            return newFormData
        });
    } 

    return {
        showNotification: showNotification,
        showPrompt: showPrompt,
        data: formData.data,
        setData: (data, dataHasChanges = false) => {
            let newData = data ? JSON.parse(JSON.stringify(data)) : null;
            setFormData(x => {
                let newFormData = {
                    ...x,
                    data: newData,
                    settings: {
                        ...x.settings,
                        hasChanges: newData && dataHasChanges ? true : false
                    }
                };
                return newFormData
            });
        },
        getFieldValue: (field) => {
            let fieldParts = field.split(".");
            let result = formData.data;
            fieldParts.forEach(f => result = result[f]);
            return result;
        },
        hasChanges: formData.settings.hasChanges,
        fieldsDisabled: !formData.data || formData.settings.saveInProgress || formData.settings.deleteInProgress,
        saveInProgress: formData.settings.saveInProgress,
        deleteInProgress: formData.settings.deleteInProgress,
        setSaveInProgress: (value) => setFormData(x => ({ ...x, settings: { ...x.settings, saveInProgress: value ? true : false } })),
        setDeleteInProgress: (value) => setFormData(x => ({ ...x, settings: { ...x.settings, deleteInProgress: value ? true : false } })),
        handleChange: handleChange,
        handleChangeControl: function handleChangeControl(event) {
            let value;
            switch (event.target.type) {
                case "checkbox":
                    value = event.target.checked;
                    break;
                default:
                    value = event.target.value;
                    break;
            }
            handleChange([{ field: event.target.name, value: value }]);
        }
    };
}